//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import UploadFile from '../../../../shared-components/upload/UploadFile';

import { basePath } from '../../../../common/resources/importacoes';

export default {
  name: 'MargemContribuicaoSidebar',
  data() {
    return {
      dialogForm: false,
    };
  },
  computed: {
    ...mapGetters('importacao', {
      tiposImportacao: 'getTiposImportacao',
    }),
    importUrl() {
      return `${basePath}/importacao`;
    },
    subtitle() {
      return this.$t('subtitle.importar_arquivo', {
        thing: this.$tc('label.margemcontribuicao', 1).toLowerCase(),
      });
    },
    uploadFileDropzoneId() {
      return `myVueDropzone${(Math.random() * Math.random() * 100).toString().replace('.', '')}`;
    },
    tipoImportacao() {
      return this.tiposImportacao.find(el => el.nome === 'importacao_margemContribuicaoRoi');
    },
  },
  components: {
    UploadFile,
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      formData.append('id_tipo_importacao', this.importacao.id);
    },
    open() {
      this.dialogForm = true;
    },
    uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
      this.dialogForm = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/margem-roi/MargemContribuicaoSidebar.vue?vue&type=script&lang=js&